import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { Icon } from 'app/shared/icon';

@Component({
    selector: 'stby-modal-close-button',
    imports: [Icon, TranslatePipe],
    templateUrl: './modal-close-button.html',
    styleUrl: './modal-close-button.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalCloseButton {
    clicked = output<MouseEvent>();
}
